import { motion } from "framer-motion";
import { lessonCategoriesList } from "config/optionValues";
import LessonOptionsCard from "./LessonOptionsCard";
import BackButtonHeaderPopUp from "../common/BackButtonHeader";

interface SelectLessonCategoriesPanelProps {
  selectedData: string[];
  setShowPopUp: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedData: React.Dispatch<React.SetStateAction<string[]>>;
}

/**
 * Definition of the variants of this component
 */
const variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: {
    opacity: 0,
    transition: { duration: 0.1, ease: "easeOut" },
  },
};

const SelectLessonCategoriesPanel: React.FC<
  SelectLessonCategoriesPanelProps
> = ({ selectedData, setShowPopUp, setSelectedData }) => {
  /**
   * Definition of the function when pressed back button
   */
  const handlePressBack = () => {
    // Close pop up
    setShowPopUp(false);
  };

  /**
   * Function executed when clicking one of the options
   * @param option
   * @returns
   */
  const handleCardClick = (option: { text: string; value: string }) => {
    return () => {
      // If the element is selected, then remove
      if (selectedData.includes(option.value)) {
        setSelectedData((currentList) =>
          currentList.filter((item) => option.value !== item)
        );
      }
      // Otherwise,add to the list
      else {
        setSelectedData((currentList) => [...currentList, option.value]);
      }
    };
  };

  return (
    <>
      <motion.div
        className="fixed inset-0 w-full h-full bg-neutral-500 bg-opacity-40 backdrop-blur-[2px] z-20 flex flex-col flex-grow"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1, ease: "easeOut" }}
        onClick={() => setShowPopUp(false)}
      />
      <motion.div
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1, ease: "easeOut" }}
        className="fixed w-[462px] h-fit max-h-[90%] left-0 right-0 ml-auto mr-auto px-6 pt-6 pb-8 bottom-5 bg-white rounded-3xl flex-col justify-start items-start gap-6 inline-flex z-30"
      >
        <div className="relative w-full h-fit max-h-[70vh] flex-col justify-start items-start gap-6 inline-flex">
          <div className="self-stretch justify-between items-center inline-flex">
            <div className="justify-start items-center gap-3 flex">
              <BackButtonHeaderPopUp onClick={handlePressBack} />
              <div className="text-neutral-600 text-lg font-normal font-sans leading-snug select-none">
                Lessons categories
              </div>
            </div>
          </div>
          <div className="w-full flex-col justify-start items-start gap-4 inline-flex overflow-y-auto pop-up-scrollbar">
            {lessonCategoriesList.map(
              (option: { text: string; value: string }, index: number) => {
                return (
                  <LessonOptionsCard
                    key={index}
                    text={option.text}
                    selected={selectedData.includes(option.value)}
                    onClickFunction={handleCardClick(option)}
                  />
                );
              }
            )}
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default SelectLessonCategoriesPanel;
